import React from 'react'

const ActivityLog = ({log}) => {
  return(
    <li style={{ borderBottom: '1px solid #d7d7d7', padding: '8px 0', fontSize: '14px' }} dangerouslySetInnerHTML={{__html:log}}></li>
  )
}

export default ActivityLog
